import React from 'react';
import styled from 'styled-components';

const InputWrapper = styled.div`
  input {
    border: 1px solid transparent;
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0 7px 6px 0 rgba(0, 0, 0, 0.11), 0 2px 4px 0 rgba(0, 0, 0, 0.09);
    font-size: 15px;
    font-family: inherit;
    padding: .75em 1em;
    width: 100%;
    transition: box-shadow .35s ease;

    &:focus {
      box-shadow: 0 7px 6px 0 rgba(0, 51, 160, 0.11), 0 2px 4px 0 rgba(0, 51, 160, 0.09);
    }
  }

  label {
    font-size: 16px;
    line-height: 1.5;
    font-weight: 500;
    text-align: center;
    color: var(--text-color-2);
    display: block;
    margin-bottom: .5rem;
  }

  &.Input {
    &--small input {
      max-width: 100px;
    }

    &--medium input {
      max-width: 240px;
    }
  }
`;

function Input(props) {
  const { className, id, label, ...rest } = props;

  return (
    <InputWrapper className={className}>
      <label htmlFor={id}>{label}</label>
      <input type="text" id={id} {...rest} />
    </InputWrapper>
  );
}

export default Input;
